// 检查是否在Electron环境中
const isElectron = () => {
    return typeof window !== 'undefined' &&
        typeof window.process === 'object' &&
        window.process.type === 'renderer';
};
// Electron存储适配器（使用electron-store）
class ElectronStorageAdapter {
    store;
    constructor() {
        if (isElectron()) {
            // 在实际使用时，这里会导入electron-store
            // this.store = new Store();
            console.warn('ElectronStorageAdapter: electron-store not imported yet');
        }
    }
    async getItem(key) {
        if (!this.store) {
            // 回退到localStorage
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        return this.store.get(key) || null;
    }
    async setItem(key, value) {
        if (!this.store) {
            // 回退到localStorage
            localStorage.setItem(key, JSON.stringify(value));
            return;
        }
        this.store.set(key, value);
    }
    async removeItem(key) {
        if (!this.store) {
            // 回退到localStorage
            localStorage.removeItem(key);
            return;
        }
        this.store.delete(key);
    }
    async clear() {
        if (!this.store) {
            // 回退到localStorage
            localStorage.clear();
            return;
        }
        this.store.clear();
    }
    async getAllKeys() {
        if (!this.store) {
            // 回退到localStorage
            return Object.keys(localStorage);
        }
        return Object.keys(this.store.store);
    }
}
// Web存储适配器（使用localforage）
class WebStorageAdapter {
    storage;
    constructor() {
        // 在实际使用时，这里会导入localforage
        // this.storage = localforage;
        console.warn('WebStorageAdapter: localforage not imported yet');
    }
    async getItem(key) {
        if (!this.storage) {
            // 回退到localStorage
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        return await this.storage.getItem(key);
    }
    async setItem(key, value) {
        if (!this.storage) {
            // 回退到localStorage
            localStorage.setItem(key, JSON.stringify(value));
            return;
        }
        await this.storage.setItem(key, value);
    }
    async removeItem(key) {
        if (!this.storage) {
            // 回退到localStorage
            localStorage.removeItem(key);
            return;
        }
        await this.storage.removeItem(key);
    }
    async clear() {
        if (!this.storage) {
            // 回退到localStorage
            localStorage.clear();
            return;
        }
        await this.storage.clear();
    }
    async getAllKeys() {
        if (!this.storage) {
            // 回退到localStorage
            return Object.keys(localStorage);
        }
        return await this.storage.keys();
    }
}
// 内存存储适配器（用于测试或临时存储）
class MemoryStorageAdapter {
    data = new Map();
    async getItem(key) {
        return this.data.get(key) || null;
    }
    async setItem(key, value) {
        this.data.set(key, value);
    }
    async removeItem(key) {
        this.data.delete(key);
    }
    async clear() {
        this.data.clear();
    }
    async getAllKeys() {
        return Array.from(this.data.keys());
    }
}
// 创建适当的存储适配器
const createStorageAdapter = () => {
    if (isElectron()) {
        return new ElectronStorageAdapter();
    }
    else {
        return new WebStorageAdapter();
    }
};
// 默认存储实例
export const storage = createStorageAdapter();
// 导出适配器类以供测试使用
export { ElectronStorageAdapter, WebStorageAdapter, MemoryStorageAdapter };
